import React from 'react'
import { faClose, faPencilAlt, faSave } from '@fortawesome/free-solid-svg-icons'
import { updateInvoiceInfo } from 'client/utils/api-routes-invoice'
import moment from 'moment'
import {
  $DCprimaryColor,
  DcButton,
  DcInput,
  PixelButton,
  PixelDate,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelText,
  colors,
} from 'pixel-base'
import styled from 'styled-components'

import { IPixelFactory } from '../../../../../decl.d'

const InvoiceInfo = (props) => {
  const {
    details,
    detailID,
    setDetails,
    newOrder,
    setNewOrderData,
    newOrderData,
  } = props

  const { showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [editInvoiceInfo, setEditInvoiceInfo] = React.useState(false)

  const [invoiceInfo, setInvoiceInfo] = React.useState({
    due_date: '',
    status: '',
    reference_no: '',
  })
  const handleUpdateInfo = (detailID, data) => {
    showPageLoader()
    updateInvoiceInfo(detailID, data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response) {
        setEditInvoiceInfo(false)
        setDetails(res.response)
      }
    })
  }
  React.useEffect(() => {
    setInvoiceInfo({
      due_date: details?.payment_due_date?.date,
      status: details?.invoice_status,
      reference_no: details?.reference_number,
    })
  }, [details, newOrderData])

  return (
    <PixelFlexBox flexDirection={'column'}>
      <SectionHeader>
        <PixelText
          textSize="16px"
          color="rgba(0, 0, 0, 0.84)"
          style={{ fontWeight: '600', padding: '10px' }}
        >
          Invoice Information
        </PixelText>
        <CloseButton>
          {newOrder ? (
            ''
          ) : (
            <>
              {editInvoiceInfo ? (
                <PixelIcon
                  onClick={() => {
                    setEditInvoiceInfo(false)
                  }}
                  fontSize="20px"
                  icon={faClose}
                />
              ) : (
                <>
                  {details?.invoice_status === 'open' ? (
                    <>
                      <DcButton
                        size="sm"
                        variant="link"
                        onClick={() => {
                          setEditInvoiceInfo(true)
                        }}
                      >
                        <PixelIcon color={$DCprimaryColor} icon={faPencilAlt} />
                      </DcButton>
                    </>
                  ) : (
                    <DcButton
                      size="sm"
                      variant="link"
                      showTooltip
                      tooltip="Invoice is closed"
                      style={{
                        border: 'none',
                        cursor: 'not-allowed',
                      }}
                    >
                      <PixelIcon color={'lightgrey'} icon={faPencilAlt} />
                    </DcButton>
                  )}
                </>
              )}
            </>
          )}
        </CloseButton>
      </SectionHeader>
      {newOrder ? (
        <InnerSection>
          <FormGroup>
            <DcInput
              as={'datePicker'}
              required
              type={'text'}
              name={'end_date'}
              placeholder={'Due Date'}
              value={moment(newOrderData.due_date).format(
                'YYYY-MM-DD 19:14:SS.SSSSSS',
              )}
              onChange={(e) => {
                setNewOrderData({
                  ...newOrderData,
                  due_date: moment(e).format('YYYY-MM-DD 19:14:SS.SSSSSS'),
                })
              }}
            />
          </FormGroup>
          <FormGroup>
            <DcInput
              required
              type={'text'}
              name={'city'}
              placeholder={'Customer Ref/PO #'}
              value={newOrderData.reference_number}
              onChange={(e) => {
                setNewOrderData({
                  ...newOrderData,
                  reference_number: e.target.value,
                })
              }}
            />
          </FormGroup>
        </InnerSection>
      ) : (
        <>
          {details && (
            <>
              <InnerSection>
                {editInvoiceInfo ? (
                  <>
                    <FormGroup>
                      <InputBlock>
                        <DcInput
                          as={'datePicker'}
                          required
                          type={'text'}
                          name={'end_date'}
                          placeholder={'Due Date'}
                          onChange={(e) => {
                            setInvoiceInfo({
                              ...invoiceInfo,
                              due_date: moment(e).format(
                                'YYYY-MM-DD 19:14:SS.SSSSSS',
                              ),
                            })
                          }}
                          value={invoiceInfo.due_date}
                        />
                        <DcButton
                          size="sm"
                          variant="link"
                          showTooltip
                          tooltip="Save"
                          onClick={() => {
                            handleUpdateInfo(detailID, {
                              due_date: invoiceInfo.due_date,
                            })
                          }}
                        >
                          <PixelIcon color={$DCprimaryColor} icon={faSave} />
                        </DcButton>
                      </InputBlock>
                      <InputBlock>
                        <DcInput
                          required
                          type={'text'}
                          name={'city'}
                          placeholder={'Customer Ref/PO #'}
                          value={invoiceInfo.reference_no}
                          onChange={(e) => {
                            setInvoiceInfo({
                              ...invoiceInfo,
                              reference_no: e.target.value,
                            })
                          }}
                        />
                        <PixelButton
                          onClick={() => {
                            handleUpdateInfo(detailID, {
                              reference_no: invoiceInfo.reference_no,
                            })
                          }}
                          variant="link"
                          showTooltip
                          tooltip="Save"
                          size="sm"
                        >
                          <PixelIcon color={$DCprimaryColor} icon={faSave} />
                        </PixelButton>
                      </InputBlock>
                    </FormGroup>
                  </>
                ) : (
                  <InnerSectionContent>
                    <PixelFlexBox style={{ fontSize: '12px' }}>
                      Customer Ref/PO #&nbsp;
                      {details.reference_number
                        ? details.reference_number
                        : 'Not Found'}
                    </PixelFlexBox>
                    <PixelFlexBox style={{ fontSize: '12px' }}>
                      Due Date:&nbsp;
                      <PixelDate
                        className="textSmall"
                        value={details?.payment_due_date?.date}
                        format={'pixelStandard'}
                      />
                    </PixelFlexBox>
                  </InnerSectionContent>
                )}
              </InnerSection>
            </>
          )}
        </>
      )}
    </PixelFlexBox>
  )
}

const InnerSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  border-bottom: 1px solid ${colors.grayBorderLight};
  width: 100%;
  padding: 10px 0px;
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const CloseButton = styled.div`
  padding: 10px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.84);
  font-size: 20px;
  font-weight: 600;
  &:hover {
    color: rgba(0, 0, 0, 0.87);
  }
`

const InnerSectionContent = styled.div<{ direction?: boolean; gap?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.direction ? 'row' : 'column')};
  gap: ${(props) => props.gap};
  margin: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'flex-start')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  padding: 10px 10px;
  .full-width {
    flex-grow: 1;
  }
`
const InputBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  width: 100%;
  gap: 10px;
`

const InvoiceInfoContainer = styled.div`
  border-bottom: 1px solid ${colors.grayBorderLight};
  padding: 20px 0;
`

export default InvoiceInfo
